import { useState } from 'react';
import type { ChangeEvent } from 'react';
import { useTranslations } from 'next-intl';
import concat from 'lodash/concat';
import range from 'lodash/range';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import { Checkbox } from '@silvertours/front-shared';
import {
  DropdownWrapper,
  Dropdown,
  InfoIcon,
  StyledTooltip,
} from './AgeDropdown.styles';
import { DEFAULT_AGE } from '../context';

type AgeDropdownProps = {
  value: number;
  label: string;
  onChange: (age: number) => void;
};

const AgeDropdown = ({ value, label, onChange }: AgeDropdownProps) => {
  const t = useTranslations('features.stageLegacy.stage.searchForm');
  const [showDropdown, setShowDropdown] = useState<boolean>(
    value < 26 || value > 65,
  );

  const ageDropdownData = concat(
    range(18, 26).map(item => ({
      label: item.toString(),
      value: item.toString(),
    })),
    {
      label: t('age.defaultAge'),
      value: DEFAULT_AGE.toString(),
    },
    range(66, 100).map(item => ({
      label: item.toString(),
      value: item.toString(),
    })),
  );

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const age = Number(event.target.value);
    onChange?.(age);
  };

  return (
    <DropdownWrapper>
      {showDropdown ? (
        <Dropdown
          // Clarity unmask (LPOT-1716): select content is auto-masked in every
          // masking mode regardless of ancestor attributes; must sit on the field.
          data-clarity-unmask="true"
          id="customerAge"
          label={t('age.input.label')}
          value={value}
          options={ageDropdownData}
          onChange={handleChange}
        />
      ) : (
        <Checkbox
          id="driverIsAdult"
          label={label}
          checked
          onChange={() => setShowDropdown(!showDropdown)}
        />
      )}
      <span>
        <StyledTooltip
          content={<UiLegacy.Markup content={t('age.tooltip.text')} />}
          trigger={<InfoIcon />}
          aria-label={t('age.tooltip.label')}
        />
      </span>
    </DropdownWrapper>
  );
};

export { AgeDropdown };
